import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse, showLoader} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const portafolioService = {
    getAllPortafolios,
    getAllSubPortafolios,
    getPortafolioById,
    getSubPortafolioById,
    setStatePortafolioById,
    setCrudPortafolios,
    setCrudPortafoliosSingle,
    setCrudSubPortafolioSingle,
    getProductosByFamiliaAndState,
    getAllPortafoliosByFilters,
    getPortafoliosByIds,
    getSubPortafoliosByIds,
    getAllProductos,
    setExcelPortafolios,
    setExcelSubportafolios
};

function getAllPortafolios() {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/portafolios/getAllPortafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllProductos() {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/portafolios/getAllProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllSubPortafolios() {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/portafolios/getAllSubPortafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllPortafoliosByFilters() {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/portafolios/getAllPortafoliosByFilters`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPortafolioById(data) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/portafolios/getPortafolioById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubPortafolioById(data) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/portafolios/getSubPortafolioById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPortafoliosByIds(portafolios) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({portafolios})
    };

    return fetch(`${url}/portafolios/getPortafoliosByIds`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubPortafoliosByIds(subPortafolios) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({subPortafolios})
    };

    return fetch(`${url}/portafolios/getSubPortafoliosByIds`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStatePortafolioById(data) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/portafolios/setStatePortafolioById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setCrudPortafolios(datos) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(datos)
    };

    return fetch(`${url}/portafolios/setCrudPortafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setCrudPortafoliosSingle(datos) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({datos})
    };

    return fetch(`${url}/portafolios/setCrudPortafoliosSingle`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setCrudSubPortafolioSingle(datos) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({datos})
    };

    return fetch(`${url}/portafolios/setCrudSubPortafolioSingle`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductosByFamiliaAndState(data) {

    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/portafolios/getProductosByFamiliaAndState`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setExcelPortafolios(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({portafolios: data})
    };

    return fetch(`${url}/portafolios/setExcelPortafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setExcelSubportafolios(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({subportafolios: data})
    }
    
    return fetch(`${url}/portafolios/setExcelSubportafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}




